import React from 'react'
import { Text } from 'library/atoms/Typography'
import styled from '@emotion/styled'
import { Code } from 'shared/library/molecules/EmbedCode'
import Grid from 'library/atoms/Grid'
import {
  StyleGuideMain,
  StyleGuideIdProps
} from 'shared/library/pages/StyleGuide'

const exampleDivs = (
  <>
    <div style={{ background: 'gray', padding: '20px' }}>1st</div>
    <div style={{ background: 'lightgray', padding: '20px' }}>2nd</div>
    <div style={{ background: 'gray', padding: '20px' }}>3nd</div>
  </>
)

const PROPS = {
  Description: () => (
    <Text as="div">
      <StyledWarning>
        This component is meant for internal use only until support becomes more
        ubiquitous.
      </StyledWarning>
      <p>
        The Grid component is related to the CSS Grid Layout and is the most
        powerful layout system available in CSS. It is a 2-dimensional system,
        meaning it can handle both columns and rows, unlike flexbox which is
        largely a 1-dimensional system. You work with Grid Layout by applying
        CSS rules both to a parent element (which becomes the Grid Container)
        and to that element’s children (which become Grid Items).
      </p>
      <p>
        It uses the <Code>styled-system</Code> to take all the props for{' '}
        <a
          title="Gid Layout"
          target="_blank"
          rel="noopener noreferrer"
          href="https://styled-system.com/table#grid-layout"
        >
          grid
        </a>
        ,{' '}
        <a
          title="space"
          target="_blank"
          rel="noopener noreferrer"
          href="https://styled-system.com/table/#space"
        >
          space
        </a>
        , width, minWidth and maxWidth.
      </p>
    </Text>
  ),
  examples: [
    {
      title: 'Grid',
      code: `<Grid gridGap={2} width="100%">
  <Grid gridGap={2} gridAutoFlow="column">
    {exampleDivs}
  </Grid>
  <Grid mt={10}>
    {exampleDivs}
  </Grid>
</Grid>`,
      scope: { Grid, exampleDivs }
    }
  ]
}

const GridStyleGuide = (props: StyleGuideIdProps) => (
  <StyleGuideMain {...props} {...PROPS} />
)

export default GridStyleGuide

const StyledWarning = styled.p(({ theme }) => ({
  padding: 10,
  border: `1px solid ${theme.colors.state.error}`,
  fontStyle: 'italic'
}))
